<template>
  <el-scrollbar style="width: 100%;height: 100%;overflow:auto;" always>
    <el-form style="margin: 10px;border: 1px solid #ececec" label-width="150px">
      <el-row style="margin-top: 10px;">
        <el-col :span="11" >
          <el-form-item label="关联合同：" >
            <el-input v-model="parentData.contract_no" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="合同金额：">
            <el-input v-model="contract_amount" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="收款公司：">
            <el-input v-model="receiveCompanyName" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin:0 0 10px 10px;font-size: 15px;font-weight: bold">收款单：</div>
    <el-form style="margin: 10px;border: 1px solid #ececec" label-width="150px">
      <el-row style="margin-top: 10px">
        <el-col :span="11">
          <el-form-item label="收款单号：">
            <el-input v-model="parentData.payment_no" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="计划收款时间：">
            <el-input v-model="parentData.plan_payment_date" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="计划收款金额：">
            <el-input v-model="payment_price_format" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="项款名称：">
            <el-input v-model="parentData.payment_name" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin:0 0 10px 10px;font-size: 15px;font-weight: bold">收款结果：</div>
    <el-form style="margin: 10px;border: 1px solid #ececec" label-width="150px">
      <el-row style="margin-top: 10px">
        <el-col :span="11">
          <el-form-item label="已收款金额：">
            <el-input v-model="receive_price_format" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="最新收款日期：">
            <el-input v-model="latest_payment_date"  disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="已收款比例：">
            <el-input v-model="receive_rate" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="收款状态：">
            <el-input v-model="parentData.payment_receive_status" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin:0 0 10px 10px;font-size: 15px;font-weight: bold">收款记录：</div>
    <el-form v-for="item in receivePaymentList" style="margin: 10px;border: 1px solid #ececec;position: relative" label-width="150px">
      <el-row style="margin-top: 10px">
        <el-col :span="11">
          <el-form-item label="实际收款金额：" required :disabled="item.haveInfo">
            <el-input-number :disabled="item.haveInfo" style="width: 100%" v-model="item.receive_payment_price" min="0" @change="calculatePlanActualDifference" :controls="false"  ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="实际收款日期：" required >
            <el-date-picker :disabled="item.haveInfo" v-model="item.receive_date" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="实际与计划差额：" >
            <el-input v-model="item.plan_actual_difference" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="收款方式：" required >
            <el-select :disabled="item.haveInfo" v-model="item.receive_type" >
              <el-option label="银行转账" value="银行转账" key="银行转账"></el-option>
              <el-option label="支票支付" value="支票支付" key="支票支付"></el-option>
              <el-option label="电汇支付" value="电汇支付" key="电汇支付"></el-option>
              <el-option label="商业汇票" value="商业汇票" key="商业汇票"></el-option>
              <el-option label="承兑汇票" value="承兑汇票" key="承兑汇票"></el-option>
              <el-option label="现金支付" value="现金支付" key="现金支付"></el-option>
              <el-option label="信用证" value="信用证" key="信用证"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：" >
            <el-input :disabled="item.haveInfo" v-model="item.remark" type="textarea" rows="2"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="21">
          <el-form-item label="附件：" required>
            <kf-file-upload v-if="item.haveInfo" :disabled="item.haveInfo" v-model:init-file="item.file_list" :limit="10" ></kf-file-upload>
            <kf-file-upload v-else :disabled="item.haveInfo" v-model="item.file_ids" @fileChange="fileChange(item,$event)" :limit="10" ></kf-file-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-button v-if="!item.haveInfo" style="position: absolute;right: 10px;bottom: 10px" @click="delList(item.id)" type="danger">删除记录</el-button>
    </el-form>

    <div style="width: 100%;margin:10px 0 10px 0;text-align: center">
      <el-button v-if="!parentData.payment_status" type="primary" @click="addLine" plain>新增收款记录</el-button>
      <el-button v-if="!parentData.payment_status" type="primary" @click="saveData" plain>保存</el-button>
    </div>

  </el-scrollbar>

</template>


<script>

import {nanoid} from "nanoid";

export default {
  name: "CrmWinPaymentItem",
  inject: ['$fn'],

  props:{
    parentData:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },

  data(){
    return {
      contract_amount:0,
      payment_price:0,
      payment_price_format:'',
      receive_price_format:'',
      receive_price:0,
      receivePaymentList:[],
      latest_payment_date:'',
      receive_rate:'',
      receiveCompanyName:[],


    }
  },
  created() {
    this.initForm();

  },
  mounted() {

  },

  methods:{
    async initForm(){
      await this.addLine();
      await this.getLatestReceiveDate();
      await this.getReceivePrice();
      await this.getReceiveCompany();
      this.contract_amount = this.formatMoney(this.parentData.total_amount);
      this.payment_price_format = this.formatMoney(this.parentData.payment_price);
      this.payment_price = this.parentData.payment_price;
      await this.calculateReceiveRate();

      await this.getPaymentItemList();
      this.calculatePlanActualDifference();
    },
    async getPaymentItemList(){
      let params = {payment_no:this.parentData.payment_no}
      let data = await this.$http('crmWinService.getPaymentItemList',params);
      for (let item of data){
        item.haveInfo = true;
      }
      this.receivePaymentList = data;
      if(!this.parentData.payment_status){
        this.addLine();
      }


    },
    saveData(){
      let list = [];
      let i = 1;
      for (let item of this.receivePaymentList){
        if(!item.receive_payment_price){
          this.$message.error('第'+i+'条收款记录，收款金额不能为空');
          return;
        }
        if(!item.receive_date){
          this.$message.error('第'+i+'条收款记录，收款日期不能为空');
          return;
        }
        if(!item.receive_type){
          this.$message.error('第'+i+'条收款记录，收款方式不能为空');
          return;
        }
        if(!item.file_ids || item.file_ids.length === 0){
          this.$message.error('第'+i+'条收款记录，附件不能为空');
          return;
        }
        list.push(item);
        i++;
      }
      let params = {
        receivePaymentList:list,
        payment_no:this.parentData.payment_no,
        payment_price:this.payment_price,
        chance_id:this.parentData.chance_id,
        phase:this.parentData.phase,
        contract_no:this.parentData.contract_no,
        company_id:this.parentData.company_id,
      }
      this.$http('crmWinService.savePaymentItem',params).then(()=>{
        this.$message.success("提交成功");
        this.$fn.search();
        this.$fn.closeWindow();
      });
    },
    //获取收款公司名称
    async getReceiveCompany(){
      this.receiveCompanyName = await this.$http('crmWinService.getBelongCompanyName',{chance_id:this.parentData.chance_id});
    },

    //获取最新的收款日期
    async getLatestReceiveDate(){
      let params = {payment_no:this.parentData.payment_no}
      this.latest_payment_date = await this.$http('crmWinService.getLatestReceiveDate',params);
    },
    //计算收款比例
    calculateReceiveRate(){
      let receive_price = this.receive_price;
      let payment_price = this.payment_price;
      if(receive_price === 0){
        this.receive_rate = 0 + '%';
      }else {
        this.receive_rate = (receive_price / payment_price * 100).toFixed(2) + '%';
      }
    },
    calculatePlanActualDifference(){
      let differenceTotal = 0;
      for (let item of this.receivePaymentList){
        if(item.receive_payment_price){
          let difference = this.payment_price - differenceTotal - item.receive_payment_price;
          differenceTotal += item.receive_payment_price;
          item.plan_actual_difference = this.formatMoney(difference);
        }
      }
    },
    //获取已收款金额
    async getReceivePrice(){
      let params = {payment_no:this.parentData.payment_no}
      let price = await this.$http('crmWinService.getReceivePrice',params);
      this.receive_price = price;
      this.receive_price_format = this.formatMoney(price);
    },

    //将数字转换成金额显示
    formatMoney(num) {
      if(!num){
        return 0;
      }
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },

    addLine(){
      this.receivePaymentList.push(
          {
            id:nanoid(),
          }
      )
    },
    delList(id){
      for (let item of this.receivePaymentList){
        if(item.id === id){
          this.receivePaymentList.splice(this.receivePaymentList.indexOf(item),1)
        }
      }
    },
    fileChange(item,ids) {
      if (ids.length <= 0) {
        item.file_ids = '';
      }else {
        item.file_ids = ids;
      }
    },

  }
}
</script>

<style scoped>

</style>